import React, { useState } from 'react';
import Modal2 from 'components/commons/modal/Modal2';
import Loading from 'components/commons/loading/Loading';

type Props = {
  hide: () => void;
  isShow: boolean;
  showNextModal: () => void;
  submit: () => Promise<{ tag: 'Success' | 'Error' }>;
};

export const EditConfirmeModal = ({
  hide,
  isShow,
  showNextModal,
  submit,
}: Props): React.ReactElement => {
  const [isUpdating, setIsUpdating] = useState<boolean>(false);

  const next = (): void => {
    const regist = async () => {
      setIsUpdating(true);
      const result = await submit();
      setIsUpdating(false);

      switch (result.tag) {
        case 'Success':
          hide();
          showNextModal();
          return;
        case 'Error':
          return;
      }
    };
    regist();
  };

  return (
    <Modal2 isShow={isShow}>
      <div className="p-4 max-h-modal overflow-y-auto">
        <div className="flex flex-col text-bluegray-700">
          <div className="flex flex-row">
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="font-bold text-bluegray-700 text-lg">
            実績がリセットされます。
          </div>
          <div className="text-sm mt-4">
            これまでの実績がリセットされチャートが再作成されます。
            <br />
            更新してもよろしいですか？
          </div>
          <button
            className="w-full flex justify-center mt-6 py-3 text-base text-white bg-tradewell rounded-lg shadow"
            onClick={next}>
            {isUpdating ? (
              <Loading
                loading={isUpdating}
                circularLoading
                style={{ width: '45px', height: '27px' }}
              />
            ) : (
              'はい'
            )}
          </button>
          <button
            className="mt-4 p-2 text-gray-500 text-center text-sm"
            onClick={hide}>
            キャンセル
          </button>
        </div>
      </div>
    </Modal2>
  );
};
